import {
	LocalizationDataType,
	useTranslate,
} from '@above-the-treeline/localization';
import { LoadingSpinnerSize } from '../LoadingSpinner';
import './loadingApp.less';

type LoadingAppProps = {
	titleKey?: string;
	titleData?: LocalizationDataType;
};

export default function LoadingApp({ titleKey, titleData }: LoadingAppProps) {
	const { translate } = useTranslate();
	return (
		<div className="loading-app">
			<div className="loading-spinner">
				<img
					className="icon-community"
					src="./community-logo-v2.png"
					style={{
						width: LoadingSpinnerSize.xlarge,
						height: LoadingSpinnerSize.xlarge,
					}}
					alt=""
				/>
			</div>
			{titleKey && (
				<span className="loading-message">
					{translate(titleKey, titleData)}
				</span>
			)}
		</div>
	);
}
